// setByPath — scrive un valore in profondità in un oggetto seguendo un percorso
// puntato (es. "menu.lists.0.categories.2.items.1.name"). I segmenti numerici sono
// indici di array. Usato dall'editing INLINE: il nodo nell'anteprima porta il suo
// data-field = percorso dentro SiteContent, e l'editor lo applica alla bozza con
// questa funzione generica (niente switch per campo). I contenitori intermedi
// esistono già (l'utente vede/edita solo elementi presenti), ma li creiamo per
// sicurezza. value === undefined → rimuove la chiave (campo opzionale svuotato).
export function setByPath(obj: any, path: string, value: unknown): void {
  if (!obj || !path) return;
  const segs = path.split('.');
  let o = obj;
  for (let k = 0; k < segs.length - 1; k++) {
    const s = segs[k];
    const nextIsIdx = /^\d+$/.test(segs[k + 1]);
    if (o[s] == null) o[s] = nextIsIdx ? [] : {};
    o = o[s];
  }
  const last = segs[segs.length - 1];
  if (value === undefined) {
    if (!Array.isArray(o)) delete o[last];
  } else {
    o[last] = value;
  }
}
